import React, { Component } from "react";
import $ from "jquery";

class EServices extends Component {
  state = {
    userCertificateEmploymentRequestJson: [],
    userPayrollDeductionRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isHomePage: true,
    isCertificateEmployment: false,
    isPayrollDeduction: false,
    isCertificateEmploymentRegister: false,
    isPayrollDeductionRegister: false,
  };
  componentDidMount() {
    this.getCertificateEmploymentRequest();
    this.getPayrollDeductionRequest();
  }
  toggleCertificateEmployment = () => {
    this.setState({ isCertificateEmployment: true });
    this.setState({ isPayrollDeduction: false });
    this.setState({ isCertificateEmploymentRegister: false });
    this.setState({ isPayrollDeductionRegister: false });
    this.setState({ isHomePage: false });
  };
  togglePayrollDeduction = () => {
    //this.setState({ isCertificateEmployment: false });
    //this.setState({ isPayrollDeduction: true });
    //this.setState({ isCertificateEmploymentRegister: false });
    //this.setState({ isPayrollDeductionRegister: false });
    //this.setState({ isHomePage: false });
  };
  toggleCertificateEmploymentRegister = () => {
    this.setState({
      isCertificateEmploymentRegister: !this.state
        .isCertificateEmploymentRegister,
    });
  };
  togglePayrollDeductionRegister = () => {
    this.setState({
      isPayrollDeductionRegister: !this.state.isPayrollDeductionRegister,
    });
  };
  getCertificateEmploymentRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("RequestType", "CertificateEmployment");

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-all-electronic-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userCertificateEmploymentRequestJson: myObject.data },
                function() {
                  //console.log(this.state.userCertificateEmploymentRequestJson);
                }
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getPayrollDeductionRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("RequestType", "PayrollDeduction");

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-all-electronic-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userPayrollDeductionRequestJson: myObject.data },
                function() {
                  //console.log(this.state.userCertificateEmploymentRequestJson);
                }
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  handleCertificateEmploymentRequest = (e) => {
    this.declineRequest(e, "CertificateEmployment");
  };
  handlePayrollDeductionRequest = (e) => {
    this.declineRequest(e, "PayrollDeduction");
  };

  declineRequest = (e, RequestType) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ElectronicRequestID", e);
      formdata.append("RequestType", RequestType);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/del-user-electronic-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              if (RequestType === "CertificateEmployment")
                this.getCertificateEmploymentRequest();
              else this.getPayrollDeductionRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  thosandSepratorBlur = (el) => {
    var element = $("#" + el);
    if (element !== null) {
      var amount = $(element).val();
      var val = amount.replace(/,/g, "");
      var e = "۰".charCodeAt(0);
      var NewVal = val.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      NewVal = NewVal.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      NewVal = NewVal.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      var parts = NewVal.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(element).val(parts.join("."));
    }
  };
  render() {
    $(".NumberValid").on("input", function() {
      var e = "۰".charCodeAt(0);
      this.value = this.value.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      this.value = this.value.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      this.value = this.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
    });
    const myCertificateEmploymentRequest = this.state.userCertificateEmploymentRequestJson.map(
      (e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <div className="mb-2">
            <span className="bg-dark text-white wp-text-small rounded p-1">
              تاریخ درخواست {e.Create_DateTime}
            </span>
          </div>
          <div className="title mb-2">
            <strong>{e.ElectronicRequestTypeTitle}</strong>
          </div>
          {/* <div className='d-grid mb-2'>
                    <span className='bg-success text-white px-2 py-1 wp-text'>{(e.Start_Date !== null) ? <span className='wp-text-small'>از </span> : <span></span>}<b>{e.Start_Date}</b></span>
                    {(e.End_Date !== null) ? <span className='bg-danger text-white px-2 py-1 wp-text'><span className='wp-text-small'>تا </span><b>{e.End_Date}</b></span> : <span></span>}
                </div> */}
          <div className="bg-primary text-white px-2 py-1 wp-text">
            به: <b>{e.ToNameCompany}</b>
          </div>
          <div className="px-2 py-1 wp-text">
            وضعیت درخواست:{" "}
            <span className={e.CustomClass}>
              <b>{e.StateTitle}</b>
            </span>
          </div>
          {e.CompleteProcessing === true ? (
            <div className="text-left">
              <a
                className="btn btn-sm btn-outline-success"
                href={e.FileAddress}
                rel="noopener noreferrer"
                target="_blank"
                title={e.FileName}
              >
                دریافت گواهی
              </a>
            </div>
          ) : null}
          {e.CanDelete === true ? (
            <div className="text-left">
              <button
                type="button"
                onClick={() =>
                  this.handleCertificateEmploymentRequest(e.ElectronicRequestID)
                }
                className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
              >
                انصراف
              </button>
            </div>
          ) : null}
        </li>
      )
    );
    const myPayrollDeductionRequest = this.state.userPayrollDeductionRequestJson.map(
      (e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <div className="mb-2">
            <span className="bg-dark text-white wp-text-small rounded p-1">
              تاریخ درخواست {e.Create_DateTime}
            </span>
          </div>
          <div className="title mb-2">
            <strong>{e.ElectronicRequestTypeTitle}</strong>
          </div>
          {/* <div className='d-grid mb-2'>
                <span className='bg-success text-white px-2 py-1 wp-text'>{(e.Start_Date !== null) ? <span className='wp-text-small'>از </span> : <span></span>}<b>{e.Start_Date}</b></span>
                {(e.End_Date !== null) ? <span className='bg-danger text-white px-2 py-1 wp-text'><span className='wp-text-small'>تا </span><b>{e.End_Date}</b></span> : <span></span>}
            </div> */}
          <div className="bg-primary text-white px-2 py-1 wp-text">
            به: <b>{e.ToNameCompany}</b>
          </div>
          <div className="bg-info text-white px-2 py-1 wp-text">
            <span>
              مبلغ تسهیلات: <b>{e.LoanAmount}</b>
            </span>
            <br></br>
            <span>
              قسط ماهیانه: <b>{e.LoanAmountMonthly}</b>
            </span>
            <br></br>
            <span>
              تسهیلات گیرنده:{" "}
              <b>
                {e.PersonFullName} ({e.PersonFatherName}) - {e.PersonNationalID}
              </b>
            </span>
          </div>
          <div className="px-2 py-1 wp-text">
            وضعیت درخواست:{" "}
            <span className={e.CustomClass}>
              <b>{e.StateTitle}</b>
            </span>
          </div>
          {e.CompleteProcessing === true ? (
            <div className="text-left">
              <a
                className="btn btn-sm btn-outline-success"
                href={e.FileAddress}
                rel="noopener noreferrer"
                target="_blank"
                title={e.FileName}
              >
                دریافت گواهی
              </a>
            </div>
          ) : null}
          {e.CanDelete === true ? (
            <div className="text-left">
              <button
                type="button"
                onClick={() =>
                  this.handleCertificateEmploymentRequest(e.ElectronicRequestID)
                }
                className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
              >
                انصراف
              </button>
            </div>
          ) : null}
        </li>
      )
    );
    if (this.state.isHomePage === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header small">فرم‌های الکترونیک</p>
            <div className="alert alert-info">
              <p className="mb-0 text-justify">
                ابتدا درخواست مورد نظر خود را انتخاب نمایید، بعد از تکمیل فرم و
                ثبت نهایی آن درخواست شما برای واحد منابع انسانی ارسال خواهد شد.
              </p>
            </div>
            <div className="item text-center">
              <button
                onClick={this.toggleCertificateEmployment}
                className="btn btn-info rounded-0"
              >
                <span>گواهی اشتغال به کار</span>
              </button>
              <button
                onClick={this.togglePayrollDeduction}
                className="btn btn-primary rounded-0"
              >
                <span>گواهی کسر از حقوق</span>
              </button>
              <div className="w-100"></div>
              <div className="text-left mt-2">
                <small>کد مدرک: SA-FO-1604/01</small>
                <br></br>
                <small>تاریخ بازنگری: 1402/12/13</small>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.isCertificateEmployment === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            {this.state.isCertificateEmploymentRegister !== true ? (
              <React.Fragment>
                <p className="wp-header small">گواهی اشتغال به کار</p>
                <ul className="Array p-0 mb-5">
                  {myCertificateEmploymentRequest.length === 0 ? (
                    <li className="Array-item">
                      <div className="title">
                        هنوز درخواستی توسط شما ثبت نشده است.
                      </div>
                    </li>
                  ) : (
                    myCertificateEmploymentRequest
                  )}
                </ul>
                <button
                  onClick={this.toggleCertificateEmploymentRegister}
                  className="btn btn-success wp-button-add"
                >
                  <span>درخواست جدید</span>
                </button>
              </React.Fragment>
            ) : (
              <div className="bg-light mt-2 p-2">
                <p className="wp-header text-center">گواهی اشتغال به کار</p>
                <p className="mb-0">
                  نام و نام‌خانوادگی:{" "}
                  <strong>{this.props.userJson.full_name}</strong>
                </p>
                <p className="mb-0">
                  نام پدر: <strong>{this.props.userJson.fa_name}</strong>
                </p>
                <p className="mb-0">
                  شماره پرسنلی:{" "}
                  <strong>{this.props.userJson.personeliCode}</strong>
                </p>
                <p className="mb-0">
                  شماره ملی: <strong>{this.props.userJson.national_id}</strong>
                </p>
                <p className="mb-0">
                  پست سازمانی:{" "}
                  <strong>{this.props.userJson.semat_title}</strong>
                </p>
                <p className="mb-0">
                  تاریخ استخدام:{" "}
                  <strong>{this.props.userJson.recruitmentDate}</strong>
                </p>
                <p className="text-justify mt-2">
                  اینجانب با مشخصات فوق متقاضی صدور گواهی اشتغال به کار جهت
                  ارائه به سازمان زیر می باشم. لذا در صورت موافقت دستورات لازم
                  را صادر فرمایید.
                </p>
                <input
                  id="CertificateEmploymentOrganization"
                  type="text"
                  placeholder="نام سازمان"
                  className="form-control"
                ></input>
                <input
                  id="CertificateEmploymentToDetails"
                  type="text"
                  placeholder="کد / نام شعبه"
                  className="form-control mt-2"
                ></input>
                <input
                  id="CertificateEmploymentDescription"
                  type="text"
                  placeholder="علت درخواست"
                  className="form-control mt-2"
                ></input>
                <div className="text-left mt-2">
                  <button
                    className="btn btn-danger rounded-0"
                    onClick={this.toggleCertificateEmploymentRegister}
                  >
                    انصراف
                  </button>
                  <button
                    className="btn btn-primary rounded-0"
                    onClick={this.submitForm}
                  >
                    ثبت درخواست
                  </button>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      );
    } else if (this.state.isPayrollDeduction === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            {this.state.isPayrollDeductionRegister !== true ? (
              <React.Fragment>
                <p className="wp-header small">گواهی کسر از حقوق</p>
                <ul className="Array p-0 mb-5">
                  {myPayrollDeductionRequest.length === 0 ? (
                    <li className="Array-item">
                      <div className="title">
                        هنوز درخواستی توسط شما ثبت نشده است.
                      </div>
                    </li>
                  ) : (
                    myPayrollDeductionRequest
                  )}
                </ul>
                <button
                  onClick={this.togglePayrollDeductionRegister}
                  className="btn btn-success wp-button-add"
                >
                  <span>درخواست جدید</span>
                </button>
              </React.Fragment>
            ) : (
              <div className="bg-light mt-2 p-2">
                <p className="wp-header text-center">گواهی اشتغال به کار</p>
                <p className="mb-0">
                  نام و نام‌خانوادگی:{" "}
                  <strong>{this.props.userJson.full_name}</strong>
                </p>
                <p className="mb-0">
                  نام پدر: <strong>{this.props.userJson.fa_name}</strong>
                </p>
                <p className="mb-0">
                  شماره پرسنلی:{" "}
                  <strong>{this.props.userJson.personeliCode}</strong>
                </p>
                <p className="mb-0">
                  شماره ملی: <strong>{this.props.userJson.national_id}</strong>
                </p>
                <p className="mb-0">
                  پست سازمانی:{" "}
                  <strong>{this.props.userJson.semat_title}</strong>
                </p>
                <p className="mb-0">
                  تاریخ استخدام:{" "}
                  <strong>{this.props.userJson.recruitmentDate}</strong>
                </p>
                <p className="text-justify mt-2">
                  اینجانب با مشخصات فوق متقاضی صدور گواهی کسر از حقوق جهت ارائه
                  به سازمان زیر با مشخصات وارد شده می باشم. لذا در صورت موافقت
                  دستورات لازم را صادر فرمایید.
                </p>
                <div>
                  <label className="small font-weight-bold">
                    نام سازمان / بانک<abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="PayrollDeductionOrganization"
                    type="text"
                    className="form-control rounded-0"
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div>
                  <label className="small font-weight-bold">
                    مبلغ کل تسهیلات<abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="LoanAmount"
                    type="text"
                    className="form-control rounded-0 NumberValid"
                    defaultValue="0"
                    onKeyUp={() => this.thosandSepratorBlur("LoanAmount")}
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div>
                  <label className="small font-weight-bold">
                    اقساط ماهیانه<abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="LoanMonthlyAmount"
                    type="text"
                    className="form-control rounded-0 NumberValid"
                    defaultValue="0"
                    onKeyUp={() =>
                      this.thosandSepratorBlur("LoanMonthlyAmount")
                    }
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div>
                  <label className="small font-weight-bold">
                    نام گیرنده تسهیلات<abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="PersonFullName"
                    type="text"
                    className="form-control rounded-0"
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div>
                  <label className="small font-weight-bold">
                    نام پدر گیرنده تسهیلات<abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="PersonFatherName"
                    type="text"
                    className="form-control rounded-0"
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div>
                  <label className="small font-weight-bold">
                    شماره ملی گیرنده تسهیلات
                    <abbr className="text-danger">*</abbr>
                  </label>
                  <input
                    id="PersonNationalID"
                    type="text"
                    className="form-control rounded-0"
                  ></input>
                  <div className="invalid-feedback wp-text-small"></div>
                </div>
                <div className="text-left mt-2">
                  <button
                    className="btn btn-danger rounded-0"
                    onClick={this.togglePayrollDeductionRegister}
                  >
                    انصراف
                  </button>
                  <button
                    className="btn btn-primary rounded-0"
                    onClick={this.submitForm}
                  >
                    ثبت درخواست
                  </button>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      );
    } else {
    }
  }
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      if (this.state.isCertificateEmployment === true) {
        var OrganizationName = document.getElementById(
          "CertificateEmploymentOrganization"
        ).value;
        var ToDetails = document.getElementById(
          "CertificateEmploymentToDetails"
        ).value;
        var Description = document.getElementById(
          "CertificateEmploymentDescription"
        ).value;
        if (OrganizationName !== null && OrganizationName.length > 0) {
          var formdata = new FormData();
          formdata.append("token", token);
          formdata.append("RequestType", "CertificateEmployment");
          formdata.append("OrganizationName", OrganizationName);
          formdata.append("ToDetails", ToDetails);
          formdata.append("Description", Description);
          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-electronic-request`,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              if (result !== null) {
                var myObject = JSON.parse(result);
                if (myObject.status === 0) {
                  errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                  this.toggleCertificateEmployment();
                  this.getCertificateEmploymentRequest();
                } else {
                  errorMessage = myObject.message;
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              }
            })
            .catch((error) => console.log("error", error));
        } else {
          errorMessage = "محل ارائه گواهی اشتغال به کار را مشخص نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      } else if (this.state.isPayrollDeduction === true) {
        var PayrollOrganizationName = document.getElementById(
          "PayrollDeductionOrganization"
        ).value;
        if (
          PayrollOrganizationName !== null &&
          PayrollOrganizationName.length > 0
        ) {
          var LoanAmount = document.getElementById("LoanAmount").value;
          if (LoanAmount !== null && LoanAmount.length > 0) {
            var LoanMonthlyAmount = document.getElementById("LoanMonthlyAmount")
              .value;
            if (LoanMonthlyAmount !== null && LoanMonthlyAmount.length > 0) {
              var PersonFullName = document.getElementById("PersonFullName")
                .value;
              if (PersonFullName !== null && PersonFullName.length > 0) {
                var PersonFatherName = document.getElementById(
                  "PersonFatherName"
                ).value;
                if (PersonFatherName !== null && PersonFatherName.length > 0) {
                  var PersonNationalID = document.getElementById(
                    "PersonNationalID"
                  ).value;
                  if (
                    PersonNationalID !== null &&
                    PersonNationalID.length > 0
                  ) {
                    var Payrollformdata = new FormData();
                    Payrollformdata.append("token", token);
                    Payrollformdata.append("RequestType", "PayrollDeduction");
                    Payrollformdata.append(
                      "OrganizationName",
                      PayrollOrganizationName
                    );
                    Payrollformdata.append("LoanAmount", LoanAmount);
                    Payrollformdata.append(
                      "LoanMonthlyAmount",
                      LoanMonthlyAmount
                    );
                    Payrollformdata.append("PersonFullName", PersonFullName);
                    Payrollformdata.append(
                      "PersonFatherName",
                      PersonFatherName
                    );
                    Payrollformdata.append(
                      "PersonNationalID",
                      PersonNationalID
                    );

                    var PayrollrequestOptions = {
                      method: "POST",
                      body: Payrollformdata,
                      redirect: "follow",
                    };

                    fetch(
                      `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-electronic-request`,
                      PayrollrequestOptions
                    )
                      .then((response) => response.text())
                      .then((result) => {
                        if (result !== null) {
                          var myObject = JSON.parse(result);
                          if (myObject.status === 0) {
                            errorMessage =
                              "درخواست شما با موفقیت در سامانه ثبت شد.";
                            this.props.toggleErrorMessage(errorMessage);
                            this.props.toggleError();
                            this.togglePayrollDeduction();
                            this.getPayrollDeductionRequest();
                          } else {
                            errorMessage = myObject.message;
                            this.props.toggleErrorMessage(errorMessage);
                            this.props.toggleError();
                          }
                        }
                      })
                      .catch((error) => console.log("error", error));
                  } else {
                    errorMessage = "کدملی تسهیلات گیرنده را مشخص نمایید.";
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                  }
                } else {
                  errorMessage = "نام پدر تسهیلات گیرنده را مشخص نمایید..";
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              } else {
                errorMessage = "نام تسهیلات گیرنده را مشخص نمایید.";
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            } else {
              errorMessage = "اقساط ماهیانه را وارد نمایید.";
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          } else {
            errorMessage = "مبلغ تسهیلات را وارد نمایید.";
            this.props.toggleErrorMessage(errorMessage);
            this.props.toggleError();
          }
        } else {
          errorMessage = "محل ارائه گواهی کسر از حقوق را مشخص نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default EServices;
